import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=42ba79ae&scoped=true&lang=pug"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"
import style0 from "./Section.vue?vue&type=style&index=0&id=42ba79ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba79ae",
  null
  
)

export default component.exports